export const enum MenuUiType {
  Primary,
  Secondary,
}
